<template>
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    title="Thông tin"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <component
        :is="detailFormComponent"
        :dialog="dialog"
        :fields="fields"
        :features_count="features_count"
      />
    </base-form>
    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="EDIT_TYPE.UPDATE"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { sdk } from '@service/http/axios'
import { EDIT_TYPE } from '@constant'
import cloneDeep from 'lodash/cloneDeep'
import DatastoreDetailVectorForm from './detail-info-vector-form.vue'
import DatastoreDetailRasterForm from './detail-info-raster-form.vue'
export default {
  props: {
    fields: { type: Array, required: true },
    features_count: { type: Number, required: true },
  },
  components: {
    DatastoreDetailVectorForm,
    DatastoreDetailRasterForm,
  },
  data: () => ({
    EDIT_TYPE,
    dialog: {
      show: false,
      loading: false,
      data: {
        meta: {
          bbox_4326: [],
        },
      },
      error: {},
    },
  }),
  watch: {},
  computed: {
    isRasterType() {
      return ['tif', 'tiff', 'pdf'].includes(this.dialog.data.type)
    },

    detailFormComponent() {
      return this.isRasterType
        ? 'DatastoreDetailRasterForm'
        : 'DatastoreDetailVectorForm'
    },
  },
  methods: {
    open(item) {
      if (this.$refs.form) this.$refs.form.resetValidation()

      this.dialog.show = true

      const data = cloneDeep(item)

      if (!data.meta || Array.isArray(data.meta)) {
        data.meta = {}
      }

      if (['tif', 'tiff', 'pdf'].includes(data.type)) {
        if (!data.meta.bbox) data.meta.bbox = {}
        if (!data.meta.wgs84_bbox) data.meta.wgs84_bbox = {}
        if (!data.meta.wgs84Extent) data.meta.wgs84Extent = null
        if (!data.meta.bands) data.meta.bands = []
        if (!data.meta.band_count) data.meta.band_count = data.meta.bands.length
      } else {
        if (!data.meta.bbox_4326) data.meta.bbox_4326 = []
      }

      this.$set(this.dialog, 'data', data)
    },
    dialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: { meta: { bbox_4326: [] } },
        error: {},
      }
      this.$emit('reset')
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        if (!this.isRasterType && this.dialog.data.meta.bbox_4326) {
          this.dialog.data.meta.bbox_4326 = this.dialog.data.meta.bbox_4326.map(
            (x) => parseFloat(x)
          )
        }
        let data = Object.assign({}, this.dialog.data)
        let res = await sdk.request({
          url: `datastore-details/${this.dialog.data.id}/`,
          method: 'put',
          data: data,
        })
        if (res && !res.error) {
          this.dialogClose()
          this.$store.dispatch('notify/success', {
            message: res.data.message,
          })
          this.getData()
        }
      } catch (error) {
        if (error.response.status == 422) {
          const response = error.response
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
    onChangeParams(field_name) {
      this.$set(this.dialog.data.meta, 'field_name', field_name)
    },
  },
}
</script>

<style scoped></style>
